export type AuthorizationErrorCode =
  | "not_in_allowed_group"
  | "groups_claim_missing"
  | "groups_overage"
  | "tenant_not_found"
  | "user_not_active";

const AUTH_ERROR_MESSAGES: Record<AuthorizationErrorCode, string> = {
  not_in_allowed_group:
    "Your sign-in succeeded, but your account is not in an approved Situate access group. Contact your administrator.",
  groups_claim_missing:
    "Your sign-in succeeded, but your identity provider did not send the group information Situate needs. Contact your administrator.",
  groups_overage:
    "Your sign-in succeeded, but your identity provider sent too many group memberships for Situate to authorise from the token. Contact your administrator.",
  tenant_not_found: "Your account is not associated with an active Situate tenant.",
  user_not_active: "Your Situate user account is not active.",
};

export const AUTHORIZATION_ERROR_CODES: readonly AuthorizationErrorCode[] = [
  "not_in_allowed_group",
  "groups_claim_missing",
  "groups_overage",
  "tenant_not_found",
  "user_not_active",
] as const;

export function getAuthErrorMessage(code: string | undefined): string {
  if (!code) {
    return "Authorisation failed. Please contact your administrator.";
  }

  if (isAuthorizationError(code)) {
    switch (code) {
      case "not_in_allowed_group":
        return AUTH_ERROR_MESSAGES.not_in_allowed_group;
      case "groups_claim_missing":
        return AUTH_ERROR_MESSAGES.groups_claim_missing;
      case "groups_overage":
        return AUTH_ERROR_MESSAGES.groups_overage;
      case "tenant_not_found":
        return AUTH_ERROR_MESSAGES.tenant_not_found;
      case "user_not_active":
        return AUTH_ERROR_MESSAGES.user_not_active;
    }
  }

  return `Authorisation failed: ${code}`;
}

export function isAuthorizationError(code: string | undefined): code is AuthorizationErrorCode {
  if (!code) {
    return false;
  }

  return (AUTHORIZATION_ERROR_CODES as readonly string[]).includes(code);
}
